import {
    BonusDepositPanelAccordionWrapperStyled,
    BonusDepositPanelContainerStyled,
    BonusDepositPanelIconContainerStyled,
    BonusDepositPanelMoneyStyled,
    BonusDepositPanelTotalAmountStyled,
    BonusDepositPanelWrapperStyled
} from "./styled/BonusDepositPanelStyled";
import { BinIcon } from "../../../../components/icon/Icon";
import { Accordion, Alert, Form } from "react-bootstrap";
import { AccordionToggle } from "../../../../components/AccordionToggle/AccordionToggle";
import amountFormat from "../../../../utils/amountFormat";
import { useLangContext } from "../../../../providers/LangProvider/LangProviderContext";
import { useCallback } from "react";
import { useGTMEvent } from "../../../GoogleTagManager/googleTagManagerHooks";

function BonusDepositPanelDesktop(props) {
    const {
        className,
        depositAmount,
        initialOpenBonusTerms,
        isBonusApplied,
        handleChange,
        bonusPercent,
        bonusAmount,
        isShowDepositToBonus
    } = props;
    const {getLangPath} = useLangContext();
    const {handleGTMClick} = useGTMEvent({module: 'BonusDepositPanel'});

    const handleAccordionClose = useCallback(() => {
        handleGTMClick({accordion: 'BonusTerms', action: 'Close'});
    }, [handleGTMClick]);

    const handleAccordionOpen = useCallback(() => {
        handleGTMClick({accordion: 'BonusTerms', action: 'Open'});
    }, [handleGTMClick]);

    return <div className={className}>
        <BonusDepositPanelWrapperStyled style={{marginBottom: '20px'}}>
            <BonusDepositPanelIconContainerStyled>
                <BinIcon name="IcBonus" style={{fontSize: '23px', fill: '#B7803D'}}/>
            </BonusDepositPanelIconContainerStyled>
            <BonusDepositPanelContainerStyled>
                <div className="d-flex justify-content-between align-items-center px-2 mb-2">
                    <Form.Group>
                        <Form.Check type="switch" id="apply-bonus" className="d-flex align-items-center">
                            <Form.Check.Input
                                checked={isBonusApplied}
                                onChange={handleChange}
                                role="button"
                                style={{marginRight: '12px'}}/>
                            <Form.Label role="button" dangerouslySetInnerHTML={{
                                __html: getLangPath('bonuses.get_bonus', {percent: bonusPercent})
                            }}>
                            </Form.Label>
                        </Form.Check>
                    </Form.Group>
                    <BonusDepositPanelMoneyStyled>
                        +${amountFormat(bonusAmount, 2)}
                    </BonusDepositPanelMoneyStyled>
                </div>
                <Accordion
                    defaultActiveKey={initialOpenBonusTerms ? 0 : undefined}
                    as={BonusDepositPanelAccordionWrapperStyled}
                >
                    <Accordion.Item eventKey={0}>
                        <AccordionToggle
                            eventKey={0}
                            onClose={handleAccordionClose}
                            onOpen={handleAccordionOpen}
                        >
                            <BinIcon
                                name="IcChevronDown"
                                style={{fill: 'var(--color-secondary-active)', marginRight: '4px'}}
                            />
                            {getLangPath('bonuses.terms_title')}
                        </AccordionToggle>
                        <Accordion.Body>
                            <ol dangerouslySetInnerHTML={{__html: getLangPath('bonuses.terms')}}/>
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
            </BonusDepositPanelContainerStyled>
        </BonusDepositPanelWrapperStyled>

        {
            isShowDepositToBonus && <Alert variant={'success'}>
                <BinIcon name={'IcCheckMarkCircleGreen'} className={'me-2'}/>
                {getLangPath('bonuses.deposit_to_bonus')}
            </Alert>
        }

        {isBonusApplied && <>
            <BonusDepositPanelTotalAmountStyled>
                {getLangPath('bonuses.total_amount')}
                <BonusDepositPanelMoneyStyled>
                    ${amountFormat(+bonusAmount + +depositAmount, 2)}
                </BonusDepositPanelMoneyStyled>
            </BonusDepositPanelTotalAmountStyled>
        </>}
    </div>
}

export default BonusDepositPanelDesktop;
